import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import Educations from "../../containers/education/Educations";
import Certifications from "../../containers/certifications/Certifications";
import CompetitiveSites from "../../components/competitiveSites/CompetitiveSites";
import EducationImg from "./EducationImg";
import { competitiveSites } from "../../portfolio";
import { certifications } from "../../portfolio";
import "./EducationComponent.css";
import { Fade } from "react-reveal";
import lcimage from "./leetcode_streak.png";
import badges from "./badges.png";

class Education extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="education-main">
        <Header theme={this.props.theme} />
        <div className="basic-education">
          <Fade bottom duration={2000} distance="40px">
            <div className="heading-div">
              <div className="heading-img-div">
                {/* <img
									src={require("../../assets/images/education.svg")}
									alt=""
								/> */}
                <EducationImg theme={theme} />
              </div>
              <div className="heading-text-div">
                <h1 className="heading-text" style={{ color: theme.text }}>
                  Education
                </h1>
                {/* <CompetitiveSites logos={competitiveSites.competitiveSites} /> */}
              </div>
            </div>
          </Fade>
          <Educations theme={this.props.theme} />
          <div className="heading-text-div">
            <h1 className="heading-text" style={{ color: theme.text }}>
              Competetive Coding
            </h1>
            <CompetitiveSites logos={competitiveSites.competitiveSites} />

            <div
              style={{
                position: "relative",
                display: "inline-block",
                cursor: "pointer",
              }}
              onMouseOver={() =>
                (document.getElementById("tooltip").style.visibility =
                  "visible")
              }
              onMouseOut={() =>
                (document.getElementById("tooltip").style.visibility = "hidden")
              }
            >
              <a
                href="https://leetcode.com/u/DinoToothbrushWithNinjaSause/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={lcimage}
                  alt="Leetcode streak graph"
                  style={{
                    width: "50%",
                    height: "50%",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
                <img
                  src={badges}
                  alt="Leetcode streak graph"
                  style={{
                    width: "50%",
                    height: "50%",
                    display: "block",
                    margin: "0 auto",
                  }}
                />
              </a>
              <span
                id="tooltip"
                style={{
                  visibility: "hidden",
                  width: "250px", // Adjust width to fit the text
                  backgroundColor: "black",
                  color: "#fff",
                  textAlign: "center",
                  borderRadius: "5px",
                  padding: "5px 10px",
                  position: "absolute",
                  zIndex: 1,
                  top: "50%", // Adjust to position it vertically centered on the image
                  left: "50%",
                  transform: "translate(-50%, -50%)", // Center horizontally and vertically
                  transition: "opacity 0.3s",
                  opacity: 1,
                }}
              >
                Click to view my profile on Leetcode!!
              </span>
            </div>
          </div>
          {certifications.certifications.length > 0 ? (
            <Certifications theme={this.props.theme} />
          ) : null}
        </div>
        <Footer theme={this.props.theme} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Education;
